// @ts-check
import { archive_schedule } from '~/api/zero-api';
import ChangeScheduleStatusModal from '~/components/AdminPages/ManageSchedules/ChangeScheduleStatusModal';
import NewEditScheduleModal from '~/components/AdminPages/ManageSchedules/NewEditScheduleModal';
import ConfirmModal from '~/components/Shared/ConfirmModal';
import { useZeroContext } from '~/components/ZeroContext';
import { useCurrentUser } from '~/hooks/reduxHooks';
import useZeroSelector from '~/hooks/useZeroSelector';
import NotificationAlert from '~/other/NotificationAlert';
import { useScheduleDataGridContext } from '~/components/Forms/ScheduleDataGrid/ScheduleDataGrid.context';
import { EventNames } from '~/components/Forms/ScheduleDataGrid/ScheduleDataGrid.utils';

export function ScheduleDataGridModals({ showCreateModal, onCloseCreateModal, pageType }) {
    const { events } = useZeroContext();
    const { activeModal, setActiveModal } = useScheduleDataGridContext();
    const user = useCurrentUser();
    const teams = useZeroSelector((state) => state.teams_helper.teams);

    const closeModal = () => setActiveModal(null);
    const refreshDataGrid = () => events.emit(EventNames.REFRESH_DATA);

    const deleteSchedule = async (schedule) => {
        try {
            await archive_schedule(schedule.scheduler_uuid);
            NotificationAlert("success", "", "Schedule archived.");
            refreshDataGrid();
        } catch (err) {
            NotificationAlert("error", "", "Unable to archive schedule.");
        } finally {
            closeModal();
        }
    };

    if (showCreateModal) {
        return (
            <NewEditScheduleModal
                show
                cancel={onCloseCreateModal}
                updateSchedules={refreshDataGrid}
                setSchedule={() => {}} // Not needed for create
                schedule={null}
                user={user}
                user_teams={teams}
                page_type={pageType}
            />
        );
    }

    if (!activeModal) {
        return null;
    }

    const { key, schedule } = activeModal;

    switch (key) {
        case "edit":
            return (
                <NewEditScheduleModal
                    show
                    cancel={closeModal}
                    updateSchedules={refreshDataGrid}
                    setSchedule={() => {}} // Refreshing the grid instead
                    schedule={schedule}
                    user={user}
                    user_teams={teams}
                    page_type={pageType}
                />
            );
        case "status":
            return (
                <ChangeScheduleStatusModal
                    show
                    cancel={closeModal}
                    updateSchedules={refreshDataGrid}
                    schedule={schedule}
                />
            );
        case "delete":
            return (
                <ConfirmModal
                    show
                    cancel={closeModal}
                    title={"Archive Schedule"}
                    body={
                        "Are you sure you want to archive this schedule? Archiving will remove this schedule from your schedules list, and users will no longer be able to complete assignments on this schedule. Any open assignments will be automatically marked as excused."
                    }
                    confirmButtonName={"Archive schedule"}
                    confirm={() => deleteSchedule(schedule)}
                />
            );
        default:
            console.error(`Unknown schedule table modal '${key}'`);
    }

    return null;
} 